import React from 'react';
import { Column } from 'react-table';
import { useGetColumnConfig } from 'Components/Table/utils';

function useGetSimulationColumns() {
    const { getColConfig } = useGetColumnConfig<Simulation>();
    const columns = React.useMemo(() => {
        const regularColumns: Column<Simulation>[] = [
            // TODO: Keep it for testing purposes. Once we know which column to display, remove it
            // {
            //     Header: 'UID',
            //     accessor: 'id',
            //     id: 'id',
            //     dataType: 'text',
            //     width: 60
            // },
            {
                Header: 'Created',
                accessor: (d) => d?._formatted?.createdAt,
                id: '_formatted.createdAt',
                renderType: 'datetime',
                sortType: 'datetime',
                dataType: 'datetime',
                width: 160
            },
            {
                Header: 'Created By',
                accessor: (d: any) => d?._formatted?.createdBy,
                id: '_formatted.createdBy',
                dataType: 'text',
                width: 160
            },
            {
                Header: 'Simulation Type',
                accessor: (d) => d?._formatted?.simulationType,
                id: '_formatted.simulationType',
                renderType: 'titleCase',
                renderOptions: {
                    replace: { ACCEPTS_REJECTS: 'Accepts / Rejects' }
                },
                dataType: 'text',
                width: 160
            },
            {
                Header: 'Rules',
                accessor: 'sandbox',
                id: 'sandbox',
                renderType: 'titleCase',
                dataType: 'text',
                width: 108
            },
            {
                Header: 'Compare',
                id: 'compareFlag',
                dataType: 'text',
                accessor: 'compareFlag',
                renderType: 'titleCase',
                width: 108
            },
            {
                Header: 'Start Date',
                accessor: (d) => d?._formatted?.start,
                id: '_formatted.start',
                renderType: 'datetime',
                sortType: 'datetime',
                dataType: 'datetime',
                width: 160
            },
            {
                Header: 'Duration',
                accessor: (d) => d._formatted.duration,
                id: '_formatted.duration',
                dataType: 'text',
                width: 92
            },
            {
                Header: 'Status',
                accessor: (d) => d?._formatted?.status,
                id: '_formatted.status',
                renderType: 'titleCase',
                dataType: 'text',
                minWidth: 160
            }
            // TODO: COMMENTS descoped for now
            // {
            //     Header: () => null,
            //     accessor: 'comment',
            //     id: 'comment',
            //     renderType: 'commentIcon',
            //     disableSortBy: true,
            //     width: 32,
            //     Cell: (props) => (props.value ? props.value : '')
            // },
            // TODO: export and delete descoped for now, temporarily removing entire kebab menu
            // {
            //     Header: () => null,
            //     accessor: 'id',
            //     id: 'id',
            //     renderType: 'overrideCell',
            //     disableSortBy: true,
            //     width: 32,
            //     Cell: ({ value: id }: { value: string }) => {
            //         return (
            //             <RowActionDropdown
            //                 menuId={`${id}-action-dropdown`}
            //                 menuActions={
            //                     [
            //                         {
            //                             testId: 'export-simulation-csv',
            //                             label: t('Export CSV'),
            //                             handleAction: () => {},
            //                         },
            //                         {
            //                             testId: 'delete-simulation',
            //                             label: t('Delete'),
            //                             handleAction: () => {},
            //                             style: { color: 'var(--red000)' }
            //                         }
            //                     ]
            //                 }
            //             />
            //         );
            //     }
            // }
        ];
        return regularColumns.map(getColConfig);
    }, [getColConfig]);

    return columns;
}

export default useGetSimulationColumns;
